module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "select-user-section",
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-flex', {
    staticClass: "dismiss-section",
    attrs: {
      "xs12": "",
      "sm12": ""
    },
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "popup-section",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "title-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('h2', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('v-flex', {
    staticClass: "search-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "search-box"
  }, [_c('div', {
    staticClass: "search-container"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('svg', {
    attrs: {
      "width": "20px",
      "height": "20px",
      "viewBox": "0 0 28 28",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("Group 22")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Design",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "searchIcon",
      "transform": "translate(-732.000000, -61.000000)",
      "stroke": "#FFFFFF",
      "stroke-width": "1.5999999"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group-29",
      "transform": "translate(710.000000, 50.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group-22",
      "transform": "translate(23.000000, 12.000000)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "Oval-2",
      "cx": "11.375",
      "cy": "11.375",
      "r": "11.375"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M19.5,19.5 L25.59375,25.59375",
      "id": "Line",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])])])])])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    staticClass: "search-field",
    attrs: {
      "type": "search",
      "id": "search",
      "placeholder": "Search"
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.loadUsers()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  })])])])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "list-section",
    attrs: {
      "xs12": ""
    }
  }, _vm._l((_vm.filtered_users), function(user, index) {
    return _c('v-flex', {
      key: index,
      staticClass: "user-item",
      attrs: {
        "xs12": ""
      },
      on: {
        "click": function($event) {
          if ($event.target !== $event.currentTarget) { return null; }
          _vm.onSelectUser(user)
        }
      }
    }, [_c('router-link', {
      attrs: {
        "to": '/' + user.slug
      }
    }, [_c('div', {
      staticClass: "avatar-image",
      style: ({
        'background-image': 'url(' + user.avatar.thumb.url + ')',
      })
    })]), _vm._v(" "), _c('label', {
      staticClass: "user-name",
      on: {
        "click": function($event) {
          _vm.onSelectUser(user)
        }
      }
    }, [_vm._v("\n          " + _vm._s(user.username) + "\n          "), (user.user_type == 'artist') ? _c('v-icon', {
      staticClass: "user-status",
      class: {
        online: user.status == 'active'
      }
    }, [_vm._v("fa-check-circle")]) : _vm._e()], 1)], 1)
  }))], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ce5dbf7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/selectusermodal.vue
// module id = 1689
// module chunks = 180